document.addEventListener('DOMContentLoaded', function () {
  const popup = document.querySelector('.ctm-whatsapp-popup');
  const phoneInput = popup?.querySelector('#WhatsAppNotifyNumber');
  const form = popup?.querySelector('#WhatsAppNotifyForm');
  const submitButton = form?.querySelector('[type="submit"]');
  const message = popup?.querySelector('#WhatsAppNotifyMessage');

  if (!popup || !phoneInput || !form || !submitButton) return;

  const companyId = 'V7wdR9'; // ✅ Your Klaviyo public API key

  const isMobileCountrySelector =
  window.matchMedia('(max-width: 767px)').matches;

const iti = window.intlTelInput(phoneInput, {
  initialCountry: 'ps',
  onlyCountries: ['ps', 'il', 'jo'],
  countryOrder: ['ps', 'il', 'jo'],
  countrySelectorMode: 'dropdown',
  countrySearch: !isMobileCountrySelector,
  separateDialCode: true,
  nationalMode: true,
  strictMode: true,
  autoPlaceholder: 'off',
  useFullscreenPopup: false,
  loadUtils: () => import(
    'https://cdn.jsdelivr.net/npm/intl-tel-input@25.3.1/build/js/utils.js'
  )
});

  let productTitle = '';
  let productUrl = '';

  // Open popup from the product card button
  document.addEventListener('click', function (e) {
    const button = e.target.closest('.new-ctm--klaviyo-button_');
    if (!button) return;

    e.preventDefault();

    const card = button.closest('.product-card');
    const cardSelect = card?.querySelector('.ctm-product-card__variant-select');
    const popupSelect = popup.querySelector('#WhatsAppNotifyVariant');

    if (!cardSelect || !popupSelect) {
      console.error('Product select or popup select not found.');
      return;
    }

    productTitle = cardSelect.getAttribute('product-title') || '';
    productUrl = cardSelect.getAttribute('product-url') || '';

    popupSelect.innerHTML = '';

    [...cardSelect.options].forEach(option => {
      popupSelect.add(new Option(option.textContent.trim(), option.value));
    });

    popupSelect.selectedIndex = 0;
    phoneInput.value = '';
    iti.setCountry('ps');

    if (message) message.textContent = '';

    popup.setAttribute('open', '');
  });

  // Submit from the popup's Notify Me button
  form.addEventListener('submit', async function (e) {
    e.preventDefault();

    const select = popup.querySelector('#WhatsAppNotifyVariant');
    const selectedOption = select?.selectedOptions[0];

    if (!select?.value || !selectedOption) {
      if (message) message.textContent = 'Please select a size.';
      return;
    }

    try {
      await iti.promise;
    } catch (error) {
      console.error('Phone utilities failed to load:', error);
      if (message) {
        message.textContent = 'Phone validation could not load. Please try again.';
      }
      return;
    }

    if (!iti.isValidNumber()) {
      phoneInput.focus();
      if (message) {
        message.textContent = 'Please enter a valid WhatsApp number.';
      }
      return;
    }

    const variantId = select.value;
    const phoneNumber = iti.getNumber();
    const selectedSize = selectedOption.textContent.trim();

    submitButton.disabled = true;
    if (message) message.textContent = 'Submitting...';

    try {
      // Step 1: Back-in-stock subscription
      const bisResponse = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions?company_id=${companyId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2026-07-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                channels: ['WHATSAPP'],
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      phone_number: phoneNumber
                    }
                  }
                }
              },
              relationships: {
                variant: {
                  data: {
                    type: 'catalog-variant',
                    id: `$shopify:::$default:::${variantId}`
                  }
                }
              }
            }
          })
        }
      );

      if (!bisResponse.ok) {
        const errorDetails = await bisResponse.text();
        console.error('Klaviyo BIS API error:', bisResponse.status, errorDetails);
        throw new Error('Back-in-stock request failed.');
      }

      // Step 2: WhatsApp consent subscription
      const consentResponse = await fetch(
        `https://a.klaviyo.com/client/subscriptions?company_id=${companyId}`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/vnd.api+json',
            'revision': '2026-07-15'
          },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                custom_source: 'WhatsApp Back in Stock',
                profile: {
                  data: {
                    type: 'profile',
                    attributes: {
                      phone_number: phoneNumber,
                      subscriptions: {
                        whatsapp: {
                          marketing: {
                            consent: 'SUBSCRIBED'
                          },
                          transactional: {
                            consent: 'SUBSCRIBED'
                          }
                        }
                      }
                    }
                  }
                }
              },
              relationships: {
                list: {
                  data: {
                    type: 'list',
                    id: 'UEE2c5' // ✅ Your WhatsApp Subscribers list ID
                  }
                }
              }
            }
          })
        }
      );

      if (!consentResponse.ok) {
        const errorDetails = await consentResponse.text();
        console.error('Klaviyo consent API error:', consentResponse.status, errorDetails);
        throw new Error('WhatsApp consent request failed.');
      }

      if (message) {
        message.textContent = 'Request submitted successfully!';
      }

      console.log('Submitted to Klaviyo:', { selectedSize, variantId, phoneNumber });

      setTimeout(() => {
        popup.removeAttribute('open');
      }, 1500);

    } catch (error) {
      console.error('Submission error:', error);
      if (message) {
        message.textContent = 'Unable to submit your request. Please try again.';
      }
    } finally {
      submitButton.disabled = false;
    }
  });

  // Close popup
  document.addEventListener('click', function (e) {
    if (e.target.closest('.ctm-whatsapp-popup [data-modal-close]')) {
      e.preventDefault();
      popup.removeAttribute('open');
    }
  });
});